<template>
  <div class="m-iframe-wrapper">
    <iframe
      :key="generateUUID()"
      :src="url"
      :loading="lazy ? 'lazy' : 'eager'"
      class="m-iframe"
      v-show="!loading"
      ref="frame" />
    <v-progress-circular indeterminate color="primary" class="m-auto" v-show="loading" />
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref} from '@vue/composition-api'

import {generateUUID} from '@/utils/utils'

export default defineComponent({
  name: 'MIframe',
  props: {
    src: {
      type: String,
      required: true,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
    noCache: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {refs}) {
    const loading = ref(true)

    const url = computed(() => {
      const url = new URL(props.src)
      if (props.noCache) url.searchParams.set('ts', Date.now().toString())

      return url.toString()
    })

    onMounted(() => {
      const frame = refs.frame as HTMLIFrameElement

      frame.onload = () => {
        loading.value = false
      }

      document.onresize = () => {
        frame.style.height = `${frame.contentWindow?.document.body.scrollHeight}px`
      }
    })

    return {
      loading,
      url,
      generateUUID,
    }
  },
})
</script>

<style lang="scss" scoped>
.m-iframe-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.m-iframe {
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  margin: 0;
}
</style>
